export default [
    {
        path: '/utilisateurs',
        name: 'users',
        component: () => import('../views/Users.vue'),
        meta: {
            requiresAuth: true,
            authorize: ['ROLE_ADMIN'],
            layout: 'default',
            breadcrumb: 'niveaux de menu',
            description: 'Gestion des niveaux de menu'
        }
    }
]
